import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUserPool, validateEmail } from "../../services/api/apiClient";
import { useToast } from "../../context/ToastContext";
import { ValidateEmailLink } from "../../services/api/types/auth/validateEmailLink";
import { setAxiosUserEmail } from "../../services/api/axiosInstance";
import {
  UserEmailQueryParams,
  LoginFlow,
} from "../../services/api/types/auth/userPool";

interface LoadingPageProps {}

export const LoadingPage: React.FC<LoadingPageProps> = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const extractParams = () => {
    const url = window.location.toString();
    const linkQuery = url.split("loading?&")[1]; // everything after "loading?&"
    const queryLikeParts = url.split("?&").slice(1);

    const params: Record<string, string> = {};

    queryLikeParts.forEach((segment) => {
      const [rawKey, ...rawValueParts] = segment.split("=");
      if (rawKey && rawValueParts.length > 0) {
        let rawValue = rawValueParts.join("=");
        try {
          rawValue = decodeURIComponent(rawValue);
        } catch (e) {
          console.warn("Failed to decode value", rawValue);
        }
        const txt = document.createElement("textarea");
        txt.innerHTML = rawValue;
        rawValue = txt.value;
        params[rawKey] = rawValue;
      }
    });

    const { userName, confirmationCode, form } = params;
    return {
      userName,
      confirmationCode,
      form,
      linkQuery,
      params,
    };
  };

  useEffect(() => {
    if (window.location.pathname.includes("/loading")) {
      const handleNavigation = async () => {
        try {
          const { userName, confirmationCode, form, linkQuery, params } =
            extractParams();

          const emailQueryParams: UserEmailQueryParams = {
            email: userName,
            loginFlow:
              form === "ca" ? LoginFlow.FIRST_TIME_LOGIN : LoginFlow.LOGIN,
            portalUrl: window.location.origin,
          };
          const userPoolResponse = await getUserPool(emailQueryParams);
          setAxiosUserEmail(userPoolResponse.cognitoUser);

          const validateEmailParams: ValidateEmailLink = {
            linkQuery: linkQuery,
            poolId: userPoolResponse.poolId,
          };
          const response = await validateEmail(validateEmailParams);
          if (response) {
            if (userName && confirmationCode && form) {
              const expiration = response.expiration
              navigate("/new-password", {
                state: { userName, confirmationCode, form, expiration },
                replace: true,
              });
            } else {
              console.error("Missing required params", params);
            }
          }
        } catch (error: any) {
          console.error("Error", error);
          showToast(error.response.data, "error");
          const timer = setTimeout(() => {
            if (error.response?.data === "Link expired.") {
              const { userName } = extractParams();
              navigate("/link-expired", {
                state: { userName, reason: "link-expired" },
                replace: true,
              });
            } else {
              navigate("/login");
            }
          }, 2000);

          return () => clearTimeout(timer);
        }
      };

      handleNavigation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return <></>;
};
